import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { AppData} from '../helpers/app-data'


export const customInterceptor: HttpInterceptorFn = (req, next) => {
  let router = inject(Router);
  const API_TOKEN = sessionStorage.getItem(AppData.localStorageToken);

  // El backend exige X-APIKey en toda petición con cuerpo, también en las anónimas del enlace de formulario expuesto.
  // Sin sesión solo se agrega en llamadas a la API, para no enviarla a otros dominios.
  let headers = req.headers;
  if (API_TOKEN || req.url.startsWith(AppData.API_URL)) {
    headers = headers.set('X-APIKey', AppData.API_KEY);
  }

  if (API_TOKEN) {
    try {
      let decodedToken: any = jwtDecode(API_TOKEN);
      const isExpired =
        decodedToken && decodedToken.exp
          ? decodedToken.exp < Date.now() / 1000
          : false;

      // La sesión del enlace no lleva al login al vencer: el formulario pide un OTP nuevo (SesionEnlaceService)
      const isTaskLinkToken = decodedToken?.TokenType === 'TaskLink';

      if (isExpired && !isTaskLinkToken) {
        sessionStorage.removeItem(AppData.localStorageToken);
        router.navigateByUrl('/login');
      } else {
        headers = headers.set('Authorization', `Bearer ${API_TOKEN}`);
      }

    } catch (error) {

      sessionStorage.removeItem(AppData.localStorageToken);
      router.navigateByUrl('/login');
    }
  }
  return next(req.clone({ headers }));
};
